export default {
  props: ['error'],

  /**
   *
   * @param h
   * @returns {*}
   */
  render (h) {
    if (
      this.error &&
      this.error.response &&
      this.error.response.status !== 401 &&
      this.error.response.data &&
      this.error.response.data.message
    ) {
      return (
        <div class="bg-red-500 text-white rounded p-5 text-xs italic mb-6" role="alert">
          {this.error.response.data.message}
        </div>
      );
    } else {
      return null;
    }
  }
}
